import React from 'react';
import './LegalPage.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page-container">
      <div className="legal-page-card">
        <div className="logo-container">
          <img src="/acta-logo.jpg" alt="Acta Extension" className="acta-logo" />
        </div>
        <h1>個人情報の取扱いについて</h1>

        <div className="legal-content">
          <p>ナウビレッジ株式会社（以下、「当社」という）は個人情報保護方針に基づき、お客様の個人情報の取扱いに細心の注意を払っております。</p>
          <p>以下、当社における個人情報の取扱いについての考え方を記載いたします。</p>

          <h2>1. 個人情報の利用目的について</h2>
          <p>当社は、当社が提供する『Acta Extension』（以下「本サービス」といいます。）の申込、登録および利用に際して取得する個人情報を、以下の目的のために利用します。</p>
          <ul>
            <li>本サービスの申込登録、本サービスの提供、本サービスにかかる請求・支払い、お問い合わせ対応並びに本サービスに関するお知らせを行うため。</li>
            <li>当社が提供するサービス、セミナー、イベント、各種情報のご案内（電子メールによる情報配信を含みます）を行うため。</li>
            <li>当社が提供するサービス全般の改善、新サービスの企画・開発その他のマーケティング目的で、個人を識別できない形式に加工した統計情報を作成・利用するため。</li>
          </ul>
          <p>本サービスの利用にあたり取得する、利用ユーザー（当該企業に所属する役員・従業員等）のメールアドレスその他の連絡先情報についても、上記に定める利用目的の範囲内で取り扱います。</p>
          <p>また、本サービスの提供にあたり、当社は、連携先サービス（HubSpot、Slack等）において提供されるユーザーID、ポータルID、レコードID、メールアドレスその他の識別情報並びに本サービスの利用状況に関するログ情報等を取得し、以下の目的のために利用します。</p>
          <ul>
            <li>ユーザー認証およびアクセス管理</li>
            <li>登録ユーザー数の管理および利用料金の算定・課金処理</li>
            <li>本サービスに関するサポート対応</li>
            <li>本サービスの安定提供、品質向上および不正利用の防止</li>
          </ul>

          <h2>2. 個人情報の安全管理措置に関して</h2>
          <p>当社は、お客様の個人情報の紛失、破壊、改ざん、漏えい等が起こらないよう適切な安全管理措置を実施し、厳正に管理します。</p>
          <p>当社が講じている安全管理措置の詳細（組織的安全管理措置、人的安全管理措置、物理的安全管理措置、技術的安全管理措置及び外的環境の把握を含みます。）については、当社ウェブサイト（<a href="https://now-village.jp/privacy_rule" target="_blank" rel="noopener noreferrer">https://now-village.jp/privacy_rule</a>）に掲載する「個人情報の取り扱い」をご参照ください。</p>

          <h2>3. 個人情報の第三者への提供について</h2>
          <p>当社は、あらかじめご本人の同意を得ることなく、個人情報を第三者に提供することはございません。</p>
          <p>ただし、次の場合には、あらかじめご本人の同意を得ることなく、個人情報を第三者に提供することがありますので、あらかじめご了承ください。</p>
          <ol>
            <li>法令に基づく場合</li>
            <li>人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
            <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難である場合</li>
            <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</li>
          </ol>

          <h2>4. 個人情報の取扱いの委託について</h2>
          <p>当社は、個人情報を取り扱う業務の全部又は一部を外部に委託することがあります。</p>
          <p>この場合、当社は、個人情報保護体制が整備された委託先を選定するとともに、適切に監督します。なお、本サービスの提供に必要な範囲で、決済処理、システム運用、データ保管等を目的として、クラウドサービス事業者その他の業務委託先に個人情報の取扱いを委託する場合があります。</p>
          <p>また、本サービスの提供にあたり、当社がユーザー（法人又は個人事業主）から個人データの取扱いの委託を受ける場合があります。この場合、当社は、個人情報の保護に関する法律に基づく受託者として、法令及び当社の個人情報保護規程に従い、適切な安全管理措置を講じたうえで当該個人データを取り扱います。</p>
          <p>本サービスの提供に必要な範囲で、外国に所在するクラウドサービス事業者のサーバーを利用する場合があります。主な利用事業者としては、米国に所在するAmazon Web Services, Inc.が含まれます。当社が利用する外国のクラウドサービスに関する詳細（外国にある第三者への提供に該当する場合の当該外国の個人情報の保護に関する制度等を含みます。）は、当社ウェブサイト（<a href="https://now-village.jp/privacy_rule" target="_blank" rel="noopener noreferrer">https://now-village.jp/privacy_rule</a>）に掲載する「個人情報の取り扱い」をご参照ください。</p>
          <p>なお、本サービスの利用契約終了後は、当社は30日以内にお客様の個人データを削除します。ただし、法令により保存が義務付けられている情報についてはこの限りではありません。</p>

          <h2>5. 個人情報の開示、苦情及び相談について</h2>
          <p>お客様は当社が管理しているお客様の保有個人データに対して、開示等（利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止及び第三者提供記録の開示）を求めることができます。開示の方法は書面または電磁的記録（PDF等）によるご提供が可能です。希望される場合は、「ナウビレッジ株式会社 個人情報相談窓口」までご連絡ください。なお、お客様の個人情報に関するお問い合わせ、苦情及び相談に関しても、同窓口までご連絡ください。</p>
          <p>保有個人データ又は第三者提供記録の開示、利用目的の通知につきましては、手数料（1件あたり1,000円以内）を頂戴しておりますので、あらかじめ御了承ください。</p>

          <h2>6. 任意性について</h2>
          <p>お客様が個人情報を当社に提供することは任意です。</p>
          <p>しかしながら、情報のご提供がない場合には、各サービスを受けられないことがあります。</p>

          <h2>7. Cookie等の利用について</h2>
          <p>当社は、本サービスの品質向上、利用状況の分析等の目的で、Cookie、IPアドレス、アクセスログ等の情報を取得・利用する場合があります。</p>
          <p>本サービスにおけるCookie等の利用および当社ウェブサイトにおけるCookie利用ツールの詳細については、当社ウェブサイト（<a href="https://now-village.jp/privacy_rule" target="_blank" rel="noopener noreferrer">https://now-village.jp/privacy_rule</a>）に掲載する「個人情報の取り扱い」をご参照ください。</p>

          <h2>8. 個人情報に関するお問い合わせ先</h2>
          <div className="contact-info">
            <p><strong>ナウビレッジ株式会社</strong></p>
            <p>代表者：今村 邦之</p>
            <p>個人情報保護管理者：三宮洋太</p>
            <p className="contact-label">【ご連絡先】</p>
            <p>ナウビレッジ株式会社 個人情報相談窓口</p>
            <p>住所：東京都港区赤坂二丁目10番5号 赤坂日ノ樹ビル2F</p>
            <p>メールアドレス：kanri@now-village.jp</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
